import { createClient } from '@sanity/client'

export const sanityClient = createClient({
  projectId: '4xapf44t',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2024-01-01',
})
